import { useQuery } from '@apollo/client'
import { ReactElement, useEffect } from 'react'

import { SelectTags } from 'components/v2/SelectTags'
import { ISelectSalesChannelsV2Props } from 'features/Services/components/SelectSalesChannelsV2/types'
import { GET_SALES_CHANNELS } from 'features/Services/queries-legacy'
import { GTSalesChannelV2, GTSalesChannelsOutput } from 'gql/types.generated'
import { ISalesChannel } from 'features/Services/components/NewServicesV2/components/OfferSettingsCard/types'
import { isEmpty } from 'lodash'

export const SelectSalesChannelsV2 = ({
  id,
  onChange,
  onBlur,
  label,
  placeholder,
  values,
  readOnlyValues,
  touched,
  errors,
  disabled,
  countryId
}: ISelectSalesChannelsV2Props): ReactElement => {
  const { data } = useQuery<{ salesChannels: GTSalesChannelsOutput }>(GET_SALES_CHANNELS, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      pagination: {
        page: 0,
        size: 10000
      },
      input: {
        countryID: countryId
      }
    }
  })

  const shownItems =
    data?.salesChannels?.items?.filter((saleChannel) => !values.map(({ name }) => name).includes(saleChannel.name)) ||
    []
  const sortedItems = [...shownItems].sort((a, b) => a.name.localeCompare(b.name))

  const handleChange = (salesChannels: ISalesChannel[]): void => {
    onChange(salesChannels)
  }

  useEffect(() => {
    if (!isEmpty(data?.salesChannels?.items)) {
      const hasSalesChannelsWithoutName = values.some(({ name }) => !name)
      if (hasSalesChannelsWithoutName) {
        onChange(
          values.map((saleChannel) => {
            const saleChannelData = data?.salesChannels?.items.find(({ id }) => id === saleChannel.id)
            if (saleChannelData) {
              return saleChannelData
            }
            return saleChannel
          })
        )
      }
    }
  }, [data])

  const shownValues = values.filter(({ name }) => Boolean(name))

  return (
    <SelectTags
      id={id}
      placeholder={placeholder}
      values={shownValues}
      readOnlyValues={readOnlyValues}
      label={label}
      items={sortedItems}
      getTagLabel={(saleChannel: GTSalesChannelV2): string => saleChannel.name}
      onChange={handleChange}
      onBlur={onBlur}
      touched={touched}
      errors={errors}
      disabled={disabled}
    />
  )
}
